import React from 'react';

import { APIContext } from 'context/api/context';

export function useAPI() {
  const context = React.useContext(APIContext);

  if (context === undefined) {
    throw new Error(
      'Hook `useAPI` and other API hooks can only be used within an APIProvider.'
    );
  }

  return context;
}
